/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_CONTACT_TYPE_DETAILS_NEW = "GET_CONTACT_TYPE_DETAILS_NEW";
export const COMPARE_CONTACT_TYPE_DATA = "COMPARE_CONTACT_TYPE_DATA";
export const CONTACT_TYPE_ROW_SELECTED = "CONTACT_TYPE_ROW_SELECTED";
export const CONTACT_TYPE_DETAILS_LOADING = "CONTACT_TYPE_DETAILS_LOADING";
export const CONTACT_TYPE_DETAILS_DATA_CHANGE_TRIED =
  "CONTACT_TYPE_DETAILS_DATA_CHANGE_TRIED";
export const CONTACT_TYPE_DETAILS_ERROR_MESSAGE =
  "CONTACT_TYPE_DETAILS_ERROR_MESSAGE";
export const CONTACT_TYPE_DETAILS_SUCCESS_MESSAGE =
  "CONTACT_TYPE_DETAILS_SUCCESS_MESSAGE";
export const CHILD_CONTACT_TYPE_ERROR = "CHILD_CONTACT_TYPE_ERROR";

export const GET_CONTACT_TYPE_DETAILS = "GET_CONTACT_TYPE_DETAILS";
export const UPDATE_CONTACT_TYPE_DETAILS = "UPDATE_CONTACT_TYPE_DETAILS";
export const RESET_SAVE_FLAG = "RESET_SAVE_FLAG";
export const RESET_CONTACT_TYPE_STORE="RESET_CONTACT_TYPE_STORE"
